import { getAuth } from "firebase/auth";
import {
  setIsLoadingAuth,
  setIsLoggedIn,
  setIsLoginData,
} from "../slices/authReducers";

/**
 * @method: Method to handle the auth change
 * @param user
 * @param route
 */
export const handleAuthChange = (user: any, route: any, dispatch: any) => {
  console.log({ user });
  // User signed In
  if (user) {
    dispatch(setIsLoggedIn(true));
    dispatch(
      setIsLoginData({
        displayName: user.displayName,
        pic: user?.photoURL,
        email: user?.email,
      })
    );

    dispatch(setIsLoadingAuth(false));
  } else {
    dispatch(setIsLoggedIn(false));
    dispatch(setIsLoadingAuth(false));
    // User signed Out
  }
};

/**
 * @method: Method to get current logged in user
 */
export const getAuthUserId = () => {
  const auth: any = getAuth();
  return auth?.currentUser?.uid ?? "";
};
/**
 * @method: Method to get current logged in name
 */
export const getAuthUserName = () => {
  const auth: any = getAuth();
  return auth?.currentUser?.displayName ?? "";
};
